<script lang="ts">
    import { link } from "svelte-routing"

    import { getContent } from "../../api"
    import { apiBaseURL } from "../../config"

    import Sidebar from "../page/Sidebar.svelte"
    import Galleries from "../page/Galleries.svelte"
    import AudioFiles from "../page/AudioFiles.svelte"

    export let path: string

    let loading = true
    let content: Content

    function load() {
        loading = true
        getContent(path)
            .then((c) => {
                content = c
            })
            .finally(() => {
                loading = false
            })
    }

    $: if (path) load()
</script>

<div class="container">
    <div class="row">
        <div class="col-md-10">
            <img
                src="assets/page/notes.svg"
                alt="Svend Walter - Noten"
                class="mt-lg mb-lg"
            />

            <div class="row content-blocks">
                {#if loading}
                    <!-- Loader -->
                {:else if content}
                    {#each content.blocks || [] as b}
                        <article class="article-details col-md-{b.columns}">
                            <div class="article-content variant-{b.variant}">
                                {#if b.title}
                                    <h2 class="article-title mb-lg">
                                        {b.title}
                                    </h2>
                                {/if}
                                {#if b.subtitle}
                                    <div class="article-subtitle">
                                        {b.subtitle}
                                    </div>
                                {/if}

                                {#if b.layout === 3}
                                    <div class="mb-lg">
                                        {#each b.images as image}
                                            <img
                                                class="layout-{b.layout}"
                                                src="{apiBaseURL}content/{content.id}/{image
                                                    .file.src}"
                                                alt="{image.label}"
                                            />
                                        {/each}
                                    </div>
                                    {#if b?.galleries?.length}
                                        <div class="mb-lg">
                                            <Galleries article="{b}" />
                                        </div>
                                    {/if}
                                    {#if b?.audioFiles}
                                        <AudioFiles
                                            block="{b}"
                                            id="{content.id}"
                                        />
                                    {/if}
                                {/if}

                                <div>
                                    {#if b.layout === 1 || b.layout === 2}
                                        {#each b.images as image}
                                            <img
                                                class="layout-{b.layout}"
                                                src="{apiBaseURL}content/{content.id}/{image
                                                    .file.src}"
                                                alt="{image.label}"
                                            />
                                        {/each}
                                    {/if}
                                    {#if b.text}
                                        <div class="article-content">
                                            {@html b.text}
                                        </div>
                                    {/if}
                                </div>
                                {#if b.button_url}
                                    <a
                                        class="article-link"
                                        href="{b.button_url}"
                                        use:link
                                    >
                                        {b.button_text}
                                    </a>
                                {/if}
                            </div>

                            {#if b.layout === 4}
                                <div>
                                    {#each b.images as image}
                                        <img
                                            class="layout-{b.layout}"
                                            src="{apiBaseURL}content/{content.id}/{image
                                                .file.src}"
                                            alt="{image.label}"
                                        />
                                    {/each}
                                    {#if b?.galleries?.length}
                                        <div class="mt-lg">
                                            <Galleries article="{b}" />
                                        </div>
                                    {/if}
                                    {#if b?.audioFiles}
                                        <AudioFiles
                                            block="{b}"
                                            id="{content.id}"
                                        />
                                    {/if}
                                </div>
                            {/if}
                        </article>
                    {/each}
                {:else}
                    <h1>Seite nicht gefunden</h1>
                    <div>Pfad: {path}</div>
                {/if}
            </div>

            <img
                src="assets/page/notes.svg"
                alt="Svend Walter - Noten"
                class="mt-lg mb-lg"
            />
        </div>
        <div class="col-md-2">
            <Sidebar />
        </div>
    </div>
</div>
